/**
 * Die Benutzer des Mandanten als Auswahl für Verantwortliche auf der Startseite – nach Namen
 * sortiert, mit der IAM-ID als Wert. Leer, wenn die Liste nicht geladen werden konnte; dann ist
 * die Auswahl nicht änderbar.
 */
import { useEffect, useState } from "react";
import { usersApi } from "../../../../services/api/users";
import { InlineUserOption } from "../../../common/inputs/InlineUserPicker";

export const useUserOptions = (): InlineUserOption[] => {
  const [users, setUsers] = useState<InlineUserOption[]>([]);
  useEffect(() => {
    let current = true;
    usersApi
      .getOrgUsers()
      .then(
        (orgUsers) =>
          current &&
          setUsers(
            orgUsers
              .map((u) => ({ id: u.user_id, name: u.name || u.email }))
              .sort((a, b) => a.name.localeCompare(b.name, "de")),
          ),
      )
      .catch(() => current && setUsers([]));
    return () => {
      current = false;
    };
  }, []);
  return users;
};
